import React from "react"
import {Navigate, Route, Routes} from "react-router-dom"

import {CreateCustomerPage} from "./CreateCustomerPage"

function DevToolsPage() {
	return (
		<Routes>
			<Route index element={<Navigate to="create-customer" replace />} />
			<Route path="create-customer" element={<CreateCustomerPage />} />
		</Routes>
	)
}

export {DevToolsPage}
